import { render, staticRenderFns } from "./userNumber.vue?vue&type=template&id=5c32b795&scoped=true"
import script from "./userNumber.vue?vue&type=script&lang=js"
export * from "./userNumber.vue?vue&type=script&lang=js"
import style0 from "./userNumber.vue?vue&type=style&index=0&id=5c32b795&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c32b795",
  null
  
)

export default component.exports